import React from 'react';
import type { IconType } from 'react-icons';

const SITEMAP_PATH =
  'M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z';

/**
 * FaSitemap with the exclamation mark from TbFlagExclamation (same paths, stroke and position on the 24px grid),
 * cutting a gap out of the sitemap around the mark the way the Tabler flag does.
 */
export const SitemapExclamation: IconType = ({ size = '1em', title, ...props }) => {
  const maskId = React.useId();
  return (
    // Plain svg rather than react-icons' IconBase: next.config.js rewrites react-icons imports to
    // @react-icons/all-files, which has no IconBase entry.
    <svg viewBox="0 0 24 24" height={size} width={size} aria-hidden={title ? undefined : true} {...props}>
      {title && <title>{title}</title>}
      <mask id={maskId}>
        <rect width="24" height="24" fill="white" />
        <rect x="15" y="13.5" width="8" height="10.5" rx="2" fill="black" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path d={SITEMAP_PATH} fill="currentColor" stroke="none" transform="translate(1 3.5) scale(0.0325)" />
      </g>
      <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 16v3" />
        <path d="M19 22v.01" />
      </g>
    </svg>
  );
};
